// OrderFeedbackQuestionTable.jsx

import React, { useState, useEffect } from "react";
import { useQuery, useMutation } from "@apollo/client";
import Sidebar from "../Sidebar";
import Layout from "../Layout";
import Loader from "../../Loader";
import DataTable from "../DataTable";
import AddOrderFeedbackQuestion from "./AddOrderFeedbackQuestion";
import {
  GET_ORDER_FEEDBACK_QUESTIONS,
  DELETE_ORDER_FEEDBACK_QUESTION,
} from "./OrderFeedbackQuestion";
import { Link } from "react-router-dom";
import { useAuthz } from "../../auth/useAuthz";
import { set } from "date-fns";

const OrderFeedbackQuestionTable = () => {
  const { loading, data } = useQuery(GET_ORDER_FEEDBACK_QUESTIONS);
  const [deleteQuestion] = useMutation(DELETE_ORDER_FEEDBACK_QUESTION);
  const { can } = useAuthz();

  const [dataList, setDataList] = useState([]);
    const [isFetched, setIsFetched] = useState(false);
  
  const [editForm, setEditForm] = useState(false);
  const [editData, setEditData] = useState(null);

  useEffect(() => {
    if (data?.getOrderFeedbackQuestions?.data) {
      setDataList(data.getOrderFeedbackQuestions.data);
      setIsFetched(true);
    }
  }, [data]);

  const handleDelete = (id) => {
    deleteQuestion({ variables: { id } }).then(() => {
      window.location.reload();
    });
  };

  const handleEdit = (row) => {
    setEditData(row);
    setEditForm(true);
  };

  if (loading || !isFetched) return <Loader />;

  return (
    <>
      {isFetched && (
        editForm ? (
        <AddOrderFeedbackQuestion
          editFormData={editData}
          setEditForm={setEditForm}
        />
      ) : (
        <div className="min-h-screen flex">
          <Sidebar />
          <Layout>
            <div className="pt-8 px-6">
              {!editForm && (
                                <div className="flex justify-between items-center">
                                  <div className="flex text-[#FBB033] items-center font-be-jost-pro text-xl font-bold space-x-3 pt-8 pl-5">
                                    <Link
                                      to="/admin/services"
                                      className="text-[#FBB034] hover:bg-white hover:text-[#00395E] rounded-sm cursor-pointer text-base px-2 py-1 font-semibold font-be-jost-pro text-center md:text-left"
                                    >
                                      <span> Services</span>
                                    </Link>
                                    <Link
                                      to="/admin/category"
                                      className=" text-[#FBB034] hover:bg-white hover:text-[#00395E] rounded-sm cursor-pointer text-base px-2 py-1 font-semibold font-be-jost-pro text-center md:text-left"
                                    >
                                      <span>Category</span>
                                    </Link>
              
                                    <Link
                                      to="/admin/sub-category"
                                      className="text-[#FBB034] hover:bg-white hover:text-[#00395E] rounded-sm cursor-pointer text-base px-2 py-1 font-semibold font-be-jost-pro text-center md:text-left"
                                    >
                                      <span>Sub Category</span>
                                    </Link>
                                    <Link
                                      to="/admin/inventory-table"
                                      className="text-[#FBB034] hover:bg-white hover:text-[#00395E] rounded-sm cursor-pointer text-base px-2 py-1 font-semibold font-be-jost-pro text-center md:text-left"
                                    >
                                      Inventory
                                    </Link>
                                    <Link
                                      to="/admin/inventory-category-table"
                                      className=" text-[#FBB034] hover:bg-white hover:text-[#00395E] rounded-sm cursor-pointer text-base px-2 py-1 font-semibold font-be-jost-pro text-center md:text-left"
                                    >
                                      <span>Inventory Category</span>
                                    </Link>
                                     <Link
                                                    to="/admin/order-feedback-question-table"
                                      className=" rounded-sm cursor-pointer text-base px-2 py-1 font-semibold font-be-jost-pro text-center md:text-left bg-white text-[#00395E]"
                                                  >
                                                    <span>Feedback Questions</span>
                                                  </Link>
                                  </div>
                                  {can("feedbackQuestions.create") && (
                                    <div>
                                     <button
                className="border border-[#ab997b] bg-black text-[#FBB033] font-be-jost-pro font-medium text-sm rounded-md px-10 py-2"
                onClick={() => {setEditForm(true); setEditData(null)}}
              >
                Add Feedback Question
              </button>
                                    </div>
                                  )}
                                </div>
                              )}
             

              <DataTable tableName="Order Feedback Questions">
                <thead>
                  <tr>
                    <th>Question</th>
                    <th>Target</th>
                    <th>Answer Type</th>
                    <th>Rating Range</th>
                    <th>Active</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {dataList.map((row) => (
                    <tr key={row.id}>
                      <td>{row.question}</td>
                      <td>{row.targetType}</td>
                      <td>{row.answerType}</td>
                      <td>
                        {row.targetType === "SERVICE" ||
                        row.targetType === "PRODUCT"
                          ? `${row.minRating ?? "any"} - ${row.maxRating ?? "any"}`
                          : "-"}
                      </td>
                      <td>{row.isActive ? "Yes" : "No"}</td>
                      <td>
                        <button
                          className="bg-white px-3 py-1 text-black rounded-md"
                          onClick={() => handleEdit(row)}
                        >
                          Edit
                        </button>

                        <button
                          className="bg-white px-3 py-1 text-black rounded-md ml-2"
                          onClick={() => handleDelete(row.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </DataTable>
            </div>
          </Layout>
        </div>
      )
      )}
    </>
  );
};

export default OrderFeedbackQuestionTable;